<template>
  <div class="container">
    <div class="scrollTop" @click="scrollToTop" v-show="showtop">
      <img src="../../assets/images/top.png" />
    </div>
    <div class="search flex w1200">
      <el-input
        v-model="searchword"
        clearable
        placeholder="请输入学科名称"
        @keyup.enter.native="toSearch"
      ></el-input>
      <el-button @click="toSearch">检索</el-button>
    </div>
    <div class="content flex w1200">
      <div class="left">
        <el-tree
          :data="schooldeplist"
          node-key="id"
          :props="{ label: 'name', id: 'id', children: 'childrenList' }"
          @node-click="handleNodeClick"
          :default-expanded-keys="expandedkey"
          :default-expand-all="alltree"
          ref="tree"
          class="custom-tree"
          highlight-current
          :render-content="renderContent"
        >
        </el-tree>
      </div>
      <div class="right" v-loading="loading">
        <el-table
          :data="topiclist"
          border
          width="100%"
          :header-cell-style="{
            background: 'rgba(21, 186, 188, 0.1)',
            'border-right': '1px solid rgba(21, 186, 188, 0.4)',
            'border-bottom': '1px solid rgba(21, 186, 188, 0.4)',
          }"
          :cell-style="{
            'border-right': '1px solid rgba(21, 186, 188, 0.4)',
            'border-bottom': '1px solid rgba(21, 186, 188, 0.4)',
          }"
        >
          <el-table-column type="index" label="序号" width="80">
          </el-table-column>
          <el-table-column prop="topicName" label="Topic" width="150">
          </el-table-column>
          <el-table-column prop="description" label="Topic描述">
          </el-table-column>
          <el-table-column label="文章数量" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="clickdetail(scope.row)"
                class="actinum"
                >{{ scope.row.worksCount }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { isshowtop } from "../../assets/js/scroll";
export default {
  data() {
    return {
      searchword: "",
      schooldeplist: [],
      topiclist: [],
      expandedkey: [],
      loading: false,
      alltree: false,
      showtop: false,
    };
  },
  watch: {},
  created() {},
  mounted() {
    var _this = this;
    window.onscroll = function () {
      if (isshowtop()) {
        _this.showtop = true;
      } else {
        _this.showtop = false;
      }
    };
    this.treelist();
  },
  methods: {
    //获取分类列表
    treelist() {
      let searchname = this.searchword.trim();
      this.$http({
        url: "api/v1/topic/subject/list?name=" + searchname,
        method: "GET",
      }).then((res) => {
        if (res.code == "200") {
          if (res.data.length > 0) {
            this.schooldeplist = res.data;
            let showid = res.data[0];
            if (!this.searchword.trim()) {
              this.$nextTick(function () {
                this.$refs.tree.setCurrentKey(showid.id); //data[0].id为默认选中的节点
              });
            }
            //默认展开
            this.expandedkey = [showid.id];
            //选中第一个和结果匹配的树
            if (this.searchword.trim()) {
              this.searchTree(res.data, this.searchword.trim());
            } else {
              let datatext = {
                id: showid.id,
              };
              this.handleNodeClick(datatext);
            }
            // 所有树节点全部展开
            if (this.searchword.trim()) {
              setTimeout(() => {
                for (
                  var i = 0;
                  i < this.$refs.tree.store._getAllNodes().length;
                  i++
                ) {
                  this.$refs.tree.store._getAllNodes()[i].expanded = true;
                }
              }, 500);
            }
          } else {
            this.$message.error("未检索到对应学科!");
            return;
          }
        }
      });
    },
    searchTree(nodesArr, searchKey) {
      this.$nextTick(function () {
        event.stopPropagation();
        for (var i = 0; i < nodesArr.length; i++) {
          if (nodesArr[i].name.indexOf(searchKey) != -1) {
            let datatext = {
              id: nodesArr[i].id,
            };
            this.handleNodeClick(datatext);
            this.alltree = !this.alltree;
            this.$refs.tree.setCurrentKey(nodesArr[i].id);
          } else {
            if (
              nodesArr[i].childrenList &&
              nodesArr[i].childrenList.length > 0
            ) {
              // 如果是vue文件，注意下面换成this.searchTree
              this.searchTree(nodesArr[i].childrenList, searchKey);
            }
          }
          break;
        }
      });
    },
    //悬浮树气泡
    renderContent(h, { node }) {
      return (
        <span class="el-tree-node__label">
          <span title={node.label}>{node.label}</span>
        </span>
      );
    },
    //点击
    handleNodeClick(data) {
      this.$refs.tree.setCurrentKey();
      this.loading = true;
      this.$http({
        url: "api/v1/topic/subject/topic/list?subjectId=" + data.id,
        method: "GET",
      }).then((res) => {
        if (res.code == "200") {
          this.topiclist = res.data;
          this.loading = false;
        }
      });
    },
    clickdetail(item) {
      sessionStorage.setItem("topicWord", JSON.stringify(item.description));
      let _url = this.$router.resolve({
        path: "/topicsearch",
      });
      window.open(_url.href, "_self");
      //this.$router.push({ path: "/topicsearch" });
    },
    //检索
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    toSearch() {
      this.treelist();
    },
    //
    scrollToTop() {
      this.showtop = false;
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 30px 0px;
  background: #fff;
  .search {
    align-items: center;

    margin: 0px auto;

    ::v-deep .el-input {
      width: 300px;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
      width: 300px;
      border: 1px solid #ccc;
      border-right: 0px;
    }
    .el-button {
      background-color: #2d8cf0;
      border-color: #2d8cf0;
      color: #ffffff;
      height: 40px;
      line-height: 6px;
      border-radius: 0px;
    }
  }
  .content {
    padding: 50px 0px;
    padding-top: 30px;
    .custom-tree {
      ::v-deep .el-tree-node__label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      ::v-deep .el-tree-node__content {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .left {
      width: 300px;
      min-height: calc(100vh - 190px);
      box-shadow: 0px 2px 8px 0px rgba(14, 144, 151, 0.18);
      overflow-y: auto;
      padding: 10px;
      ::v-deep .el-tree-node:focus > .el-tree-node__content,
      ::v-deep .el-tree-node__content:hover {
        background-color: rgba(21, 186, 188, 0.1);
      }
      ::v-deep .is-focusable {
        ::v-deep .el-tree-node__label {
          color: rgba(21, 186, 188, 1);
        }
      }
      ::v-deep
        .el-tree--highlight-current
        .el-tree-node.is-current
        > .el-tree-node__content {
        background-color: rgba(21, 186, 188, 0.1);
      }
    }
    .right {
      width: 870px;
      margin-left: 30px;
      .el-table {
        border: 1px solid rgba(21, 186, 188, 0.4);
      }
      ::v-deep
        .el-table--enable-row-hover
        .el-table__body
        tr:hover
        > td.el-table__cell {
        background-color: rgba(21, 186, 188, 0.1);
      }
      .actinum {
        color: #2d8cf0;
        text-decoration: dashed;
        cursor: pointer;
      }
    }
  }
  .scrollTop {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 999;
    cursor: pointer;
  }
}
</style>
